var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as THREE from 'three';
import { getCtx } from './get-ctx';
const DEFAULT_AUDIO_OPTIONS = {
    fftSize: 2048,
    fftSmoothingTimeConstant: 0.8,
};
export default class AudioLoader {
    constructor(rcOpt) {
        this.isPlaying = false;
        this.isEnabled = false;
        this.input = null;
        this.willPlay = null;
        const rc = Object.assign(Object.assign({}, DEFAULT_AUDIO_OPTIONS), rcOpt);
        this.ctx = getCtx();
        this.analyser = this.ctx.createAnalyser();
        this.analyser.smoothingTimeConstant = rc.fftSmoothingTimeConstant;
        this.analyser.fftSize = rc.fftSize;
        this.gain = this.ctx.createGain();
        this.gain.gain.setValueAtTime(0, this.ctx.currentTime);
        this.analyser.connect(this.gain);
        this.gain.connect(this.ctx.destination);
        this.spectrumArray = new Uint8Array(this.analyser.frequencyBinCount);
        this.samplesArray = new Uint8Array(this.analyser.frequencyBinCount);
        this.spectrum = new THREE.DataTexture(this.spectrumArray, this.analyser.frequencyBinCount, 1, THREE.LuminanceFormat, THREE.UnsignedByteType);
        this.samples = new THREE.DataTexture(this.samplesArray, this.analyser.frequencyBinCount, 1, THREE.LuminanceFormat, THREE.UnsignedByteType);
    }
    enable() {
        this.willPlay = (() => __awaiter(this, void 0, void 0, function* () {
            try {
                const stream = yield navigator.mediaDevices.getUserMedia({
                    audio: true,
                });
                this.stream = stream;
                this.input = this.ctx.createMediaStreamSource(stream);
                this.input.connect(this.analyser);
                this.isEnabled = true;
            }
            catch (e) {
                console.error(e);
            }
        }))();
    }
    disable() {
        if (this.isEnabled && this.willPlay) {
            this.willPlay.then(() => {
                var _a;
                this.isEnabled = false;
                this.input && this.input.disconnect();
                (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach((t) => t.stop());
            });
        }
    }
    update() {
        this.analyser.getByteFrequencyData(this.spectrumArray);
        this.analyser.getByteTimeDomainData(this.samplesArray);
        this.spectrum.needsUpdate = true;
        this.samples.needsUpdate = true;
    }
    getVolume() {
        let v = 0;
        this.samplesArray.forEach((x) => {
            v += Math.pow(x / 128 - 1, 2);
        });
        const rms = Math.sqrt(v / this.samplesArray.length);
        return rms;
    }
    setFftSize(fftSize) {
        this.analyser.fftSize = fftSize;
        this.spectrumArray = new Uint8Array(this.analyser.frequencyBinCount);
        this.samplesArray = new Uint8Array(this.analyser.frequencyBinCount);
        const spectrumImage = this.spectrum.image;
        spectrumImage.data = this.spectrumArray;
        spectrumImage.width = this.analyser.frequencyBinCount;
        const samplesImage = this.samples.image;
        samplesImage.data = this.samplesArray;
        samplesImage.width = this.analyser.frequencyBinCount;
    }
    setFftSmoothingTimeConstant(fftSmoothingTimeConstant) {
        this.analyser.smoothingTimeConstant = fftSmoothingTimeConstant;
    }
}
//# sourceMappingURL=audio-loader.js.map